module.exports = __webpack_public_path__ + "fonts/4ef03fd3736b8547a360edc9d501147d.svg";